export default __webpack_public_path__ + "static/media/icon-vacations.abc81534.svg";